
































































































































import { AgentModuleConfiguration, ClientAgent } from "@/models";
import { Component, Prop, Vue } from "vue-property-decorator";
import ClientEntityWithHierarchyInterface from "@/models/Agents/Interfaces/ClientEntityWithHierarchyInterface";
import ClientProductWithHierarchy from "@/models/Agents/ProductWithHierarchy";
import { differentValues } from "@/utils/tableDifferencesVisualizer";

@Component({})
export default class MatchPrincipalAccordionTable extends Vue {
  @Prop() readonly entities!: ClientEntityWithHierarchyInterface[];
  @Prop() readonly agentModuleConfiguration!: AgentModuleConfiguration;

  getCellStyle(entity: ClientEntityWithHierarchyInterface): string {
    if (entity.principalId) {
      return "text-muted";
    }
    return "";
  }

  getPrincipalId(entity: ClientEntityWithHierarchyInterface): string | number {
    return entity.principalId ?? "";
  }

  getAgencyId(entity: ClientEntityWithHierarchyInterface): string {
    return entity.currentAgency?.id ?? "";
  }

  getAgencyName(entity: ClientEntityWithHierarchyInterface): string {
    return entity.currentAgency?.name ?? "";
  }

  getAgentCompanyAgentByType(
    agentType: string,
    entity: ClientEntityWithHierarchyInterface
  ): ClientAgent | null {
    return (
      entity.currentAgentCompanyAgentAssociations?.find(
        (agentAss) => agentAss.agentType === agentType
      )?.agent || null
    );
  }

  getAgentCompanyAgentIdByType(
    agentType: string,
    entity: ClientEntityWithHierarchyInterface
  ): string | null {
    return this.getAgentCompanyAgentByType(agentType, entity)?.id || null;
  }

  getAgentCompanyAgentNameByType(
    agentType: string,
    entity: ClientEntityWithHierarchyInterface
  ): string | null {
    return this.getAgentCompanyAgentByType(agentType, entity)?.name || null;
  }

  differentValuesStyle(
    entities: ClientProductWithHierarchy[],
    property: keyof ClientProductWithHierarchy | null = null,
    func: Function | null = null,
    agentType: string | null = null
  ): string {
    return differentValues(entities, property, func, agentType)
      ? "difference-warning-field"
      : "";
  }
}
